import { get as lodashGet } from 'lodash'
import mixpanelUtils from '@/utils/mixpanel.utils'
import sentry from '@/services/sentry'

const { mixpanelAvailable } = mixpanelUtils

function _unregisterBlankProps(propObj) {
  Object.keys(propObj).forEach((key) => {
    if (!propObj[key]) {
      mixpanelUtils.unregister(key)
    }
  })
}

const setUserContext = (user) => {
  // TODO: set the User properties base on the new convention
  // email is PII and must not ride every event as a super property — it already
  // lives on the Mixpanel People profile via mixpanelUtils.identify().
  const userProps = {
    plan: user.plan,
    user_language: lodashGet(user, 'personalInformation.presenterLanguage', 'en'),
  }
  if (mixpanelAvailable) {
    // Clear the `email` super property a pre-fix build persisted for returning
    // users; it is no longer in userProps, so _unregisterBlankProps won't catch it.
    mixpanelUtils.unregister('email')
    mixpanelUtils.register(userProps)
    _unregisterBlankProps(userProps)
  }
}

const setPresentationContext = (presentation) => {
  // TODO: set the Presentation properties base on the new convention
  const presentationProps = {
    presentation_id: presentation.id,
    presentation_language: lodashGet(presentation, 'language', 'en'),
    // TODO: more props here
  }

  if (mixpanelAvailable) {
    mixpanelUtils.register(presentationProps)
    _unregisterBlankProps(presentationProps)
  }
}

const setSlideContext = (slide) => {
  // TODO: set the Slide properties base on the new convention
  const slideProps = {
    slide_id: slide.id,
    slide_type: slide.type,
    // TODO: more props here
  }
  if (mixpanelAvailable) {
    mixpanelUtils.register(slideProps)
    _unregisterBlankProps(slideProps)
  }
}

const setRouteContext = (route) => {
  const routeProps = {
    page_name: route.name,
  }

  if (mixpanelAvailable) {
    mixpanelUtils.register(routeProps)
    _unregisterBlankProps(routeProps)
  }
}

const setFolderContext = (folder) => {
  const folderProps = {
    folder_id: folder.selectedFolderId,
  }

  if (mixpanelAvailable) {
    mixpanelUtils.register(folderProps)
    _unregisterBlankProps(folderProps)
  }
}

const setFeatureFlagsContext = (featureFlags) => {
  if (!featureFlags) return
  const featureContext = {}
  const featureVariants = {}
  const flagEntries = Object.entries(featureFlags)
  if (!flagEntries.length) {
    // it's very unlikely that unleash doesn't return any feature flags
    // If that happens, something went wrong.
    sentry.captureException(new Error('Unleash returned no feature flags'), {
      tags: {
        source: 'mixpanel.context.utils.js',
      },
      extra: {
        featureFlags,
      },
    })
    return
  }
  flagEntries.forEach(([key, value]) => {
    if (value?.variant?.enabled) {
      // only track feature flags with a variant
      // to avoid overloading mixpanel with too many properties
      featureContext[key] = value?.enabled || false
      featureVariants[key] = value?.variant?.name
    }
  })
  mixpanelUtils.register({
    featureFlags: featureContext,
    featureVariants,
  })
  // technically we want to track what unleash returned
  // but mixpanel does not allow object with > 255 properties.
  // And since mixpanel sends event in batches,
  // we don't know if a blew up event can cause the whole batch to be discarded
  // So we only send eventname.
  mixpanelUtils.trackForLoginUser('featureFlagsUpdated')
}

export default {
  mixpanelAvailable,
  setUserContext,
  setPresentationContext,
  setSlideContext,
  setRouteContext,
  setFolderContext,
  setFeatureFlagsContext,
}
